var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useState, useCallback, createContext, useContext, } from 'react';
import { Toast } from './Toast';
import { uniqueId } from 'lodash';
import { useSafeArea } from '../hooks/useSafeArea';
var notificationContext = createContext({
    notifications: [],
    createNotification: function () { },
});
export var NotificationProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), notifications = _b[0], setNotifications = _b[1];
    var removeNotification = useCallback(function (notification) {
        setNotifications(function (notifications) {
            return notifications.filter(function (x) { return x.id !== notification.id; });
        });
    }, []);
    var createNotification = useCallback(function (notification) {
        notification.id = notification.id || uniqueId('notification');
        setNotifications(function (notifications) { return __spreadArray(__spreadArray([], notifications, true), [notification], false); });
        setTimeout(function () {
            setNotifications(function (notifications) {
                return notifications.map(function (x) {
                    return x.id === notification.id
                        ? __assign(__assign({}, notification), { transitioned: true }) : x;
                });
            });
        }, 100);
        if (notification.hideAfter) {
            setTimeout(function () {
                removeNotification(notification);
            }, notification.hideAfter);
        }
    }, [removeNotification]);
    // useEffect(() => {
    //   const onError = (e: any) => {
    //     createNotification({
    //       title: 'Error',
    //       message: 'There was an error communicating with the server.',
    //       details: e.message || e.reason?.message,
    //       variant: 'danger',
    //     });
    //   };
    //   window.addEventListener('unhandledrejection', onError);
    //   window.addEventListener('error', onError);
    //   return () => {
    //     window.removeEventListener('unhandledrejection', onError);
    //     window.removeEventListener('error', onError);
    //   };
    // }, [createNotification]);
    var topMargin = useSafeArea();
    return (jsx(notificationContext.Provider, { value: { notifications: notifications, createNotification: createNotification } },
        children,
        jsx("div", { sx: {
                zIndex: 'popover',
                position: 'absolute',
                right: 0,
                top: topMargin !== null && topMargin !== void 0 ? topMargin : 'env(safe-area-inset-top)',
                bottom: 0,
                p: 3,
                pointerEvents: 'none',
                maxHeight: '100vh',
                overflow: 'hidden',
            } }, notifications.map(function (notification) {
            var hideAfter = notification.hideAfter, message = notification.message, transitioned = notification.transitioned, id = notification.id, onClick = notification.onClick, onHide = notification.onHide, dismissable = notification.dismissable, props = __rest(notification, ["hideAfter", "message", "transitioned", "id", "onClick", "onHide", "dismissable"]);
            return (jsx(Toast, __assign({}, props, { key: id, sx: {
                    mb: 2,
                    transition: 'margin-top 0.8s cubic-bezier(0, 0.55, 0.45, 1)',
                    mt: transitioned ? 0 : '100vh',
                    pointerEvents: 'auto',
                }, onClick: function (e) {
                    if (onClick) {
                        onClick(e);
                    }
                    if (!e.defaultPrevented && dismissable !== false) {
                        removeNotification(notification);
                    }
                }, onClose: function () {
                    removeNotification(notification);
                    if (onHide) {
                        onHide();
                    }
                } }), message));
        }))));
};
export function useCreateNotification() {
    var createNotification = useContext(notificationContext).createNotification;
    return createNotification;
}
//# sourceMappingURL=NotificationProvider.js.map